module.exports = __webpack_public_path__ + "img/coin-red.94844c77.svg";